<template>
  <div class="signup">
    <h2>{{ $t('auth.createNewAccount') }}</h2>
    <form  name="signup" v-on:submit.prevent>
      <div class="form-group">
        <div class="input-group">
          <input type="text" id="email" required="required" v-model="email" />
          <label class="control-label" for="email">{{ $t('auth.email') }}</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input type="password" id="password" required="required" v-model="password" />
          <label class="control-label" for="password">{{ $t('auth.password') }}</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input type="text" id="name" required="required" v-model="name" />
          <label class="control-label" for="name">{{ $t('auth.fullName') }}</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="d-flex align--center justify--space-between down-container">
        <button class="btn btn-primary" @click="register" type="submit">{{ $t('auth.signUp') }}</button>
        <router-link
          class="link pl-2 text-center"
          :to="{name: 'login'}"
        >{{ $t('auth.alreadyJoined') }}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'signup',
  data () {
    return {
      name: '',
      email: '',
      password: ''
    }
  },
  methods: {
    register () {
      let data = {
        name: this.name,
        email: this.email,
        password: this.password
      }
      this.$store
        .dispatch('auth/register', data)
        .then(() => this.$router.push('login'))
        .catch(err => console.log(err))
    }
  }
}
</script>

<style lang="scss">
.signup {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
  }

  h2 {
    text-align: center;
  }
  width: 21.375rem;

  .down-container {
    margin-top: 2.6875rem;
  }
}
</style>
